import { BrowserRouter, Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import './App.css';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Home } from './Pages/home';
import { Provider } from 'react-redux';
import store from './Redux';
import { Signup } from './Registrations/signup';
import { Login } from './Registrations/login';
import { DPLogin } from './Pages/delivery_partner_login';
import { DPHome } from './Pages/dp-home';
import { DeliveryEarnings } from './Components/delivery_earnings';
import { jwtDecode } from 'jwt-decode';
import { InventoryBatchList } from './Components/product_management/inventoryBatchList';
import { OtpVerification } from './Registrations/otp-verification';
import { Dashboard } from './Components/dashboard';
import { ProductDetails } from './Components/product_management/product_details';
import { Campaign } from './Components/product_management/campaign';
import { Inventory } from './Components/product_management/inventory';
import { BatchHistory } from './Components/product_management/batch_history';
import { GeneralSettings } from './Components/settings/general_settings';
import { ContentCMS } from './Components/settings/content_cms';
import { Category } from './Components/settings/category_management';
import { SubCategory } from './Components/settings/sub_category_management';
import { OrderManagementTabs } from './Components/order_management/order_management_tabs';
import { UserReports } from './Components/reports/user_reports';
import { TestDashboard } from './Components/testing/test_dashboard';
import { OfferManagement } from './Components/offer_management/offer_details';
import { DeliveryManagement } from './Components/delivery_management/delivery_management';
import { UserManagement } from './Components/user_management';
import { Campaign_Push_notification } from './Components/campaign/campaign_push_notification';
import { AppVersionControlSettings } from './Components/settings/app_version_control';
import ProductBanner from './Components/product_management/product_banner';
import {AddInstructions} from './Components/settings/AddInstructions';
import { FranchiseManagement } from './Components/product_management/franchise';
import LandingPageAdsSettings from './Components/settings/landing_page_ads';
import Homebanner from './Components/product_management/home_banner';
import  ProfileSettings  from './Components/settings/profile_settings';
import LaunchScreenSettings from './Components/settings/launch_screen';
import KioskOrderManagement from './Components/kiosk_order_placement';
import { BOSettings } from './Components/business_operations/bo_settings';
import { BOCategorySettings } from './Components/business_operations/bo_category_settings';
import { BusinessOperationHistory } from './Components/business_operations/business_operation_history';
import { SubscriptionPlans } from './Components/subscription_management/subscription_plans';
import { UserSubscriptions } from './Components/subscription_management/user_subscriptions';
import { SubscriptionSettings } from './Components/subscription_management/subscription_settings';
import { LoyaltyConfig } from './Components/loyalty_management/loyalty_config';
import { ReferralConfig } from './Components/referral_management/referral_config';
import { WalletTopUpBonusConfig } from './Components/wallet_management/wallet_topup_bonus';
import { WalletCheckoutConfig } from './Components/wallet_management/wallet_checkout_config';
import { PlatformFeeConfig } from './Components/wallet_management/platform_fee_config';
import { BonusGrants } from './Components/wallet_management/bonus_grants';
import { MpinConfig } from './Components/mpin_management/mpin_config';
import { PromoCoupons } from './Components/coupon_management/promo_coupons';
import UserLoyalty from './Components/loyalty_management/user_loyalty';
import { GrowthFeaturesHub } from './Components/growth_hub/growth_features_hub';

// Protected Route Component for Business Operations
const ProtectedBusinessOpsRoute = ({ children }) => {
  const user_role = localStorage.getItem('role');
  const navigate = useNavigate();

  useEffect(() => {
    // Only accountant and super_admin can access
    if (!['accountant', 'super_admin'].includes(user_role)) {
      navigate('/home/dashboard');
    }
  }, [user_role, navigate]);

  // Only render if user has access
  if (!['accountant', 'super_admin'].includes(user_role)) {
    return null;
  }

  return children;
};


// Router component that wraps routes (needed for useNavigate hook)
const AppRoutes = () => {
  return (
    <Routes>
            <Route path="/signup" element={<Signup />} />
            <Route path="/otpVerification" element={<OtpVerification />} />
            <Route path='/' element={<Login />} />
            <Route path='/shino-partner' element={<DPLogin />} />
            <Route path='/dp-home' element={<DPHome />} />
            <Route path='/dp-earnings' element={<DeliveryEarnings />} />
            {/* <Route path='/batchList' element={<InventoryBatchList />} /> */}
            <Route path='/home' element={<Home />} >
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="product_details" element={<ProductDetails />} />
              <Route path="campaign" element={<Campaign />} />
              <Route path="inventory" element={<Inventory />} />
              <Route path="inventoryBatchList" element={<InventoryBatchList />} />
              <Route path="BatchHistory" element={<BatchHistory />} />
              <Route path="general" element={<GeneralSettings />} />
              <Route path="content_cms" element={<ContentCMS />} />
              <Route path="category" element={<Category />} />
              <Route path="sub_category" element={<SubCategory />} />
              <Route path="order_management" element={<OrderManagementTabs />} />
              <Route path="reports" element={<UserReports />} />
              <Route path="testing" element={<TestDashboard />} />
              <Route path="kiosk_order" element={<KioskOrderManagement />} />
              <Route path="offer_management" element={<OfferManagement />} />
              <Route path="delivery_management" element={<DeliveryManagement />} />
              <Route path="user_management" element={<UserManagement />} />
              <Route path="Campaign_push_notification" element={<Campaign_Push_notification />} />
              <Route path="app_version_control" element={<AppVersionControlSettings />} />
              <Route path="product_banner" element={<ProductBanner />} />
              <Route path="home_banner" element={<Homebanner />} />
              <Route path="launch_screen" element={<LaunchScreenSettings />} />
              <Route path="landing_page_ads" element={<LandingPageAdsSettings />} />
              <Route path="addinstruction" element={<AddInstructions />} />
              <Route path="franchise" element={<FranchiseManagement />} />
              <Route path="profile_settings" element={<ProfileSettings />} />
              <Route path="bo_settings" element={<ProtectedBusinessOpsRoute><BOSettings /></ProtectedBusinessOpsRoute>} />
              <Route path="bo_category_settings" element={<ProtectedBusinessOpsRoute><BOCategorySettings /></ProtectedBusinessOpsRoute>} />
              <Route path="business_operation_history" element={<ProtectedBusinessOpsRoute><BusinessOperationHistory /></ProtectedBusinessOpsRoute>} />
              <Route path="subscription_plans" element={<SubscriptionPlans />} />
              <Route path="user_subscriptions" element={<UserSubscriptions />} />
              <Route path="subscription_settings" element={<SubscriptionSettings />} />
              <Route path="loyalty_config" element={<LoyaltyConfig />} />
              <Route path="referral_config" element={<ReferralConfig />} />
              <Route path="wallet_topup_bonus" element={<WalletTopUpBonusConfig />} />
              <Route path="wallet_checkout_config" element={<WalletCheckoutConfig />} />
              <Route path="platform_fee_config" element={<PlatformFeeConfig />} />
              <Route path="bonus_grants" element={<BonusGrants />} />
              <Route path="mpin_config" element={<MpinConfig />} />
              <Route path="promo_coupons" element={<PromoCoupons />} />
              <Route path="user_loyalty" element={<UserLoyalty />} />
              <Route path="growth_hub" element={<GrowthFeaturesHub />} />
            </Route>
            {/* <Route path='dashboard' element={<Dashboard/>} /> */}
    </Routes>
  );
};

function App() {
  const theme = createTheme({
    palette: {
      background: { "default": "#F5F5F5", "light": "#FFFFFF","upload":"#FAFAFA","table":"#F0F4FC","filter":"#D1D5DB" },
      primary: { "button": "#ED1E79", "main": "#ED1E79" },
      secondary: { "main": "#6B7280", "border": "#D9D9D9" },
      error: { "main": "rgba(245, 39, 24, 1)" },
      text: { "primary": "#333333", "secondary": "#6B7280","login":"#000000D9","green":"#B7EB8F","red":"#FFA39E","optional":"#00000073" },
      button:{ "backgroundEdit":"#F6FFED","backgroundDelete":"#FFF1F0","blue":"#0071BC"},
      borders:{"green":"#52C41A","red":"#F5222D"}
    },
    typography: { "fontFamily": 'Poppins', }
  })

  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </Provider>
    </ThemeProvider>
  );
}

export default App;
